module.exports = __webpack_public_path__ + "assets/c7261f819afa3dd5c1ac270614d78861.mp3";